/**
 * Unique identifier of a batch operation.
 */
export enum BatchOperationEnum {
  LIST_APP_SETTINGS_VALUES = 'listAppSettingsValues',
  UPDATE_APP_SETTINGS_VALUE = 'updateAppSettingsValue',
}

/**
 * Describes a batch operation selectable in the Batch Starter.
 *
 * `defaultTargetGroups` and `defaultParameters` pre-fill the form when the
 * operation is selected to illustrate the expected input.
 */
export interface BatchOperation {
  id: BatchOperationEnum;
  description: string;
  defaultTargetGroups: string;
  defaultParameters: string;
}

/**
 * Parameters expected by the "list App Settings values" operation.
 */
export interface ListAppSettingsParameters {
  appSettings: string;
  key: string;
}

/**
 * Parameters expected by the "update an App Settings value" operation.
 */
export interface UpdateAppSettingsParameters {
  appSettings: string;
  key: string;
  value: string;
}

export const LIST_APP_SETTINGS_DEFAULT_TARGET_GROUPS: string =
  'ms-development-826341df-df4d-4269-a646-fee929fd03a5\n' +
  'ms-development-test-169ad3bd-3b1f-4447-820d-5400f465508d';

export const LIST_APP_SETTINGS_DEFAULT_PARAMETERS: string = JSON.stringify(
  {
    appSettings: 'APPSETTINGS|ACTIVE-FEATURES|1.0.0',
    key: 'physiotherapist',
  } satisfies ListAppSettingsParameters,
  null,
  2,
);

export const UPDATE_APP_SETTINGS_DEFAULT_PARAMETERS: string = JSON.stringify(
  {
    appSettings: 'APPSETTINGS|ACTIVE-FEATURES|1.0.0',
    key: 'physiotherapist',
    value: 'true',
  } satisfies UpdateAppSettingsParameters,
  null,
  2,
);

/**
 * List of the operations available in the Batch Starter selector.
 */
export const AVAILABLE_BATCH_OPERATIONS: BatchOperation[] = [
  {
    id: BatchOperationEnum.LIST_APP_SETTINGS_VALUES,
    description: "Lister les valeurs d'un App Settings",
    defaultTargetGroups: LIST_APP_SETTINGS_DEFAULT_TARGET_GROUPS,
    defaultParameters: LIST_APP_SETTINGS_DEFAULT_PARAMETERS,
  },
  {
    id: BatchOperationEnum.UPDATE_APP_SETTINGS_VALUE,
    description: "Mettre à jour la valeur d'un App Settings",
    defaultTargetGroups: LIST_APP_SETTINGS_DEFAULT_TARGET_GROUPS,
    defaultParameters: UPDATE_APP_SETTINGS_DEFAULT_PARAMETERS,
  },
];
